import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        user: JSON.parse(window.localStorage.getItem('user')) || {},
        token: window.localStorage.getItem('token') || '',
        token_expires: window.localStorage.getItem('token_expires') || -28800,
        token_refresh: window.localStorage.getItem('token_refresh') || -28800,
        //会员类型
        commonuser: window.localStorage.getItem('commonuser') ?  window.localStorage.getItem('commonuser') === 'true' : true
    },
    mutations: {
        login(state, data) {
            state.user = data.user
            state.token = data.token
            state.token_expires = data.token_expires
            state.token_refresh = data.token_refresh
            window.localStorage.setItem('user', JSON.stringify(data.user))
            window.localStorage.setItem('token', data.token)
            window.localStorage.setItem('token_expires', data.token_expires)
            window.localStorage.setItem('token_refresh', data.token_refresh)
        },
        logout(state) {
            state.user = {}
            state.token = ''
            state.token_expires = -28800
            state.token_refresh = -28800
            window.localStorage.removeItem('user')
            window.localStorage.removeItem('token')
            window.localStorage.removeItem('token_expires')
            window.localStorage.removeItem('token_refresh')
            state.commonuser = null
            window.localStorage.removeItem('commonuser')

        },
        usertype(state, data) {
            //设置会员类型
            state.commonuser = data
            window.localStorage.setItem('commonuser', (!!data).toString())
        }
    },
    actions: {
        loginAction({ commit }, data) {
            commit('login', data)
        },
        logoutAction({ commit }, token) {
            commit('logout')
        },
        usertypeAction({ commit }, data) {
            commit('usertype', data)
        }
    },
    getters: {
        account: state => state.user.account,
        name: state => state.user.name,
        token: state => state.token,
        token_expires: state => state.token_expires,
        token_refresh: state => state.token_refresh,
        commonuser: state => state.commonuser
    }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js